import {
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const PasswordInput = ({
  value,
  onChange,
  placeholder = "Password",
  dataCy = "password",
}: {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  dataCy?: string;
}) => {
  const [show, setShow] = useState(false);

  return (
    <InputGroup>
      <Input
        type={show ? "text" : "password"}
        data-cy={dataCy}
        placeholder={placeholder}
        value={value}
        variant="primary"
        onChange={(ev) => onChange(ev.target.value)}
      />
      <InputRightElement>
        <IconButton
          size="sm"
          onClick={() => setShow(!show)}
          color="#AEB3B8"
          variant="ghost"
          px="0px"
          aria-label="reveal-password"
          icon={<FontAwesomeIcon icon={["far", show ? "eye" : "eye-slash"]} />}
        />
      </InputRightElement>
    </InputGroup>
  );
};

export default PasswordInput;
